"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addOpacityToHex = void 0;
exports.getLuminance = getLuminance;
exports.percentageToHex = exports.isLight = exports.isDark = exports.hexToRgbDecimals = exports.hexToRgb = void 0;

var _browsers = require("./browsers");

var hexToRgb = function hexToRgb(hex) {
  var hexcolor = hex.replace('#', '');
  var r = parseInt(hexcolor.substr(0, 2), 16);
  var g = parseInt(hexcolor.substr(2, 2), 16);
  var b = parseInt(hexcolor.substr(4, 2), 16);
  return {
    r: r,
    g: g,
    b: b
  };
};

exports.hexToRgb = hexToRgb;

function getLuminance() {
  var _hexcolor = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '#000000';

  var _hexToRgb = hexToRgb(_hexcolor),
      r = _hexToRgb.r,
      g = _hexToRgb.g,
      b = _hexToRgb.b;

  var luminance = (r * 299 + g * 587 + b * 114) / 1000; // 0 if color is dark, 1 if color is light

  return luminance >= 128 ? 0 : 1;
}

var hexToRgbDecimals = function hexToRgbDecimals(hex) {
  var _hexToRgb2 = hexToRgb(hex),
      r = _hexToRgb2.r,
      g = _hexToRgb2.g,
      b = _hexToRgb2.b;

  return {
    r: "".concat(r / 255),
    g: "".concat(g / 255),
    b: "".concat(b / 255)
  };
};

exports.hexToRgbDecimals = hexToRgbDecimals;

var isDark = function isDark(hexcolor) {
  return getLuminance(hexcolor) === 0;
};

exports.isDark = isDark;

var isLight = function isLight(hexcolor) {
  return getLuminance(hexcolor) === 1;
};

exports.isLight = isLight;

var percentageToHex = function percentageToHex(p) {
  var percentage = Math.max(0, Math.min(100, p)); // bound percent from 0 to 100

  var intValue = Math.round(percentage / 100 * 255); // map percent to nearest integer (0 - 255)

  var hexValue = intValue.toString(16); // get hexadecimal representation

  return hexValue.padStart(2, '0').toUpperCase(); // format with leading 0 and upper case characters
};

exports.percentageToHex = percentageToHex;

var addOpacityToHex = function addOpacityToHex(hex, percentage) {
  // On mobile, the format is #AARRGGBB
  // On Mac and Windows, the format is #RRGGBBAA
  if (_browsers.isMobile) {
    return "#".concat(hex.replace('#', ''));
  } else {
    return "#".concat(hex.replace('#', '')).concat(percentageToHex(percentage));
  }
};

exports.addOpacityToHex = addOpacityToHex;